import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import Menu from './components/Menu';
import CiclesPage from './pages/CiclesPage';
import ModulsPage from './pages/ModulsPage';
import ModulDetailPage from './pages/ModulDetailPage';
import UsuarisPage from './pages/UsuarisPage';
import LoginPage from './pages/LoginPage';
import './styles.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/*" element={<PrivateApp />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

function PrivateApp() {
  const { token, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="app-loading">Carregant...</div>;
  }

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <div className="app">
      <Menu />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/cicles" element={<CiclesPage />} />
          <Route path="/moduls" element={<ModulsPage />} />
          <Route path="/moduls/:cicleId/:modulId" element={<ModulDetailPage />} />
          <Route path="/usuaris" element={<UsuarisPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function HomePage() {
  return (
    <div className="page-container">
      <h1>Benvingut a Avaluam</h1>
      <p>Plataforma educativa per a la gestió de cicles formatius.</p>
    </div>
  );
}

export default App;
